// Backend keys from permissions.json → Communication → Contacts.
export const CONTACTS_PERMISSIONS = {
  read: "Communication.Contacts.read",
  manage: "Communication.Contacts.manage",
} as const;
